import { safeDefine } from "../../registration/safe-define.js";
import { VideoSkinElement } from "../../presets/video/skin.js";
import "../../internal/skins/default-video/register.js";
//#region src/define/video/skin.ts
safeDefine(VideoSkinElement);
//#endregion

//# sourceMappingURL=skin.js.map